module.exports = __webpack_public_path__ + "media/EBCfilm.b9360771.mp4";